import { render } from "./VeganDetails.vue?vue&type=template&id=094c1a70"
import script from "./VeganDetails.vue?vue&type=script&lang=js"
export * from "./VeganDetails.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__